import React from 'react';
import { Row, Button, Col } from 'antd';
import styles from './Title.less';

const Title = ({ titleText, btn }) => (
  <Row className={styles.title}>
    <Col span={2} className={styles.text}>
      {titleText}
    </Col>
    {btn && (
      <Col span={2} offset={20}>
        <Button type="primary" onClick={() => btn.func()} disabled={!btn.state}>
          {btn.text}
        </Button>
      </Col>
    )}
  </Row>
);
export default Title;



// WEBPACK FOOTER //
// ./src/components/Title.js